import "./JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useRef } from "react";

import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons } from "./JSONToolsHeaderButtons";
import { exampleJSONforEvaluator, cheatsheet } from "../../Services/Tools";
import { JSONPathAPI, JSONTreeAPI } from "../../Services/APIService";
import { ReactComponent as Caretdown } from "../../Icons/caret-down.svg";
import { ReactComponent as Caretup } from "../../Icons/caret-up.svg";
import { ReactComponent as CheetsheetIcon } from "../../Icons/notepad.svg";

function JSONEvaluator() {
  const cheatsheetRef = useRef(null);
  const [text, setText] = useState("");
  const [treeData, setTreeData] = useState();
  const [customPath, setCustomPath] = useState("");
  const [pathResult, setPathResult] = useState();
  const [selectedPath, setSelectedPath] = useState("");
  const [mode, setMode] = useState("tree");
  const toolFav = { toolName: 'JSON Structure Analyzer', Iconpath: "/Bracketsblue.svg" };
  const [copiedPath, setCopiedPath] = useState(false);
  const [copiedTree, setCopiedTree] = useState(false);

  const lineCount = text !== "" ? (text || "").split("\n").length : 0;

  const pasteExample = () => {
    const exampleText =
      typeof exampleJSONforEvaluator === "string"
        ? exampleJSONforEvaluator
        : JSON.stringify(exampleJSONforEvaluator, null, 2);
    setText(exampleText);
  };

  const scrollToCheatsheet = () => {
    cheatsheetRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const evaluateJson = async () => {
    if (!text.trim()) return;
    try {
      const response = await JSONTreeAPI({ input: text });
      setTreeData(response?.data?.root || null);
    } catch (error) {
      console.error(error);
      setTreeData(null);
    }
  };

  const getPath = async (e) => {
    if (!text.trim() || !customPath.trim()) return;
    try {
      const response = await JSONPathAPI({ input: text, expression: customPath });
      setPathResult(response?.data?.result);
    } catch (error) {
      console.error(error);
      setPathResult(error.response?.data?.message || "Error evaluating JSON path.");
    }
  };

  const handleCopyPath = async () => {
    if (!customPath) return;
    try {
      await navigator.clipboard.writeText(customPath);
      setCopiedPath(true);
      setTimeout(() => setCopiedPath(false), 1500);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCopyTree = async () => {
    if (!selectedPath) return;
    try {
      await navigator.clipboard.writeText(selectedPath);
      setCopiedTree(true);
      setTimeout(() => setCopiedTree(false), 1500);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Col>
      {/* HEADER */}
      <ToolHeader title="JSON Structure Analyzer" description="Analyse JSON with Tree & Path evaluation" toolFav={toolFav} />

      <Row>
        <Col md={6} style={{ width: "49%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {/* TOGGLE */}
          <div className="toggle-wrapper">
            <div
              className={`toggle-switch ${mode === "evaluation" ? "active" : ""}`}
              onClick={() => setMode(mode === "evaluation" ? "tree" : "evaluation")}>
              <div className="toggle-circle" />
            </div>
            <span className="toggle-label">
              {mode === "tree" ? "Tree View" : "JSON Evaluation"}
            </span>
          </div>
          <button className="ActionButton" onClick={scrollToCheatsheet}>
            <CheetsheetIcon className="headerIcon"/>&nbsp;
            Cheatsheet</button>
        </Col>
      </Row>

      <Row className="Formatter json-formatter-row">
        {/* <Col md={12} style={{ display: "flex", gap: "20px", margin: "10px 10px 10px 0px", justifyContent: "center", alignItems: "center" }}> */}
          {/* PATH INPUT */}
          <Col xs={12} lg={6}  md={6} className="tree-view-path">
            <span className="path-label">Path</span>
            <input
              className="tree-view-text"
              onChange={(e) => setCustomPath(e.target.value)}
              placeholder="Enter your JSON path here..."
              disabled={mode === "tree"}
              value={mode === "tree" ? "" : customPath}
            />
            <img
              src="/Copy.svg"
              alt=""
              onClick={handleCopyPath}
              style={{
                pointerEvents: mode === "tree" ? "none" : "auto",
                opacity: mode === "tree" ? 0.5 : 1
              }}
            />
            {copiedPath && <span className="copy-toast">Copied!</span>}
          </Col>

          {/* TREE PATH OUTPUT */}
          <Col md={6} className="tree-view-path" aria-disabled={mode !== "tree"}>
            <span className="path-label">JSON Path Tree</span>
            <input
              className="tree-view-text"
              value={mode === "tree" ? selectedPath : ""}
              readOnly
              disabled={mode !== "tree"}
            />
            <img
              src="/Copy.svg"
              alt=""
              onClick={handleCopyTree}
              style={{
                pointerEvents: mode !== "tree" ? "none" : "auto",
                opacity: mode !== "tree" ? 0.5 : 1
              }}
            />
            {copiedTree && <span className="copy-toast">Copied!</span>}
          </Col>
        {/* </Col> */}
      </Row>

      {/* MAIN */}
      <Row className="Formatter json-formatter-row">

        {/* INPUT */}
          <Col xs={12} lg={6} className="json-formatter-column">
          <FormatterPanel
            title="Input JSON"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Paste JSON..."
            lineCount={lineCount}
            editorContainerStyle={{ overflow: "auto" }}
            wrap={false}
            headerButtons={
              <InputHeaderButtons
                primaryLabel="Example"
                onPrimary={pasteExample}
                onClear={() => {
                  setText("");
                  setTreeData(null);
                  setSelectedPath("");
                }}
                onImport={(fileContent) => setText(fileContent)}
                accept=".json"
                executeLabel={mode === "tree" ? "Get Tree" : "Evaluate"}
                showExecute={true}
                onExecute={mode === "tree" ? evaluateJson : getPath}
              />
            }
            panelStyle={{ height: "300px", width:"95%" }}
            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
            footerRight={`Size : ${new Blob([text]).size} B`}
          />
        </Col>

        {/* OUTPUT */}
          <Col xs={12} lg={6} className="json-formatter-column">
          <FormatterPanel
            title={mode === "tree" ? "Tree View" : "Evaluation Output"}
            value={JSON.stringify(pathResult, null, 2)}
            readOnly={mode === "evaluation"}
            editorContainerStyle={{ overflow: "auto" }}
            wrap={false}
            panelStyle={{ height: "300px" , width:"95%"}}
            customContent={
              mode === "tree" ? (
                <div className="tree-container">
                  {treeData ? (
                    <TreeNode
                      node={treeData}
                      onSelectPath={setSelectedPath}
                      selectedPath={selectedPath}
                    />
                  ) : (
                    <div className="tree-placeholder">
                      Click "Get Tree" to see tree
                    </div>
                  )}
                </div>
              ) : null
            }
          />
        </Col>

      </Row>

      <Row ref={cheatsheetRef}>
        <Col >
          <div className="cheatsheet-card">
            <div className="cheatsheet-header">
              <img src="/bulb.svg" alt="" />
              <span>JSONPath Cheat Sheet</span>
            </div>

            {/* HEADER ROW */}
            <div className="cheatsheet-table-header">
              <div>Expression</div>
              <div>Description</div>
              <div>Example</div>
              <div></div>
            </div>

            {/* ROWS */}
            {cheatsheet.map((item, index) => (
              <CheatRow key={index} item={item} />
            ))}
          </div>
        </Col>
      </Row>
    </Col>
  );
}

export default JSONEvaluator;



function TreeNode({ node, onSelectPath, selectedPath }) {
  const [expanded, setExpanded] = useState(true);
  const hasChildren = node.children && node.children.length > 0;

  const isMatch = node.path === selectedPath;

  return (
    <div style={{ marginLeft: "10px" }}>
      <div
        className="tree-node"
        onClick={() => {
          if (hasChildren) setExpanded(!expanded);
          onSelectPath(node.path); 
        }}
        style={{
          cursor: "pointer",
          background: isMatch ? "var(--treepath-bg-color)" : "transparent",
          padding: "4px",
          borderRadius: "4px"
        }}
      >
        {hasChildren ? (expanded ? "▼ " : "▶ ") : "• "}
        <span style={{ color: "var(--tree-txt-color)" }}>{node.key || "root"}</span>
        {!hasChildren && (
          <span style={{ color: "#60A5FA" }}> : {node.value}</span>
        )}
      </div>

      {expanded &&
        hasChildren &&
        node.children.map((child, i) => (
          <TreeNode
            key={i}
            node={child}
            onSelectPath={onSelectPath}
            selectedPath={selectedPath}
          />
        ))}
    </div>
  );
}

function CheatRow({ item }) {
  const [open, setOpen] = useState(false);


  return (
    <div className={`cheatsheet-row-wrapper ${open ? "open" : ""}`}>

      {/* MAIN ROW */}
      <div className="cheatsheet-row" onClick={() => setOpen(!open)}>
        <div className="exp">{item.Experssion}</div>
        <div>{item.Description}</div>
        <div className="example">{item.Example}</div>
        <div className="arrow">
          {open ? <Caretup className="headerIcon" /> : <Caretdown className="headerIcon" />}
        </div>
      </div>

      {/* EXPAND CONTENT */}
      {open && (
        <div className="cheatsheet-expand">
          <p className="example-title">EXAMPLE</p>
          <pre>{item.Example}</pre>
          <p className="output-title">OUTPUT</p>
          <pre>{item.Output}</pre>
        </div>
      )}
    </div>
  );
}
